import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { getPageRouteForHost } from 'shared/js/utils/DomainUtils'

// Returns the page the visitor is on. Handles case subdomain is mapped to a page
// (orders.rx.com -> "/order") the router serves that page at the subdomain root
export const useCurrentRootPath = (route: string): string => {
  const { restaurant, host } = useRestaurant()
  const currentRootPath = `/${route.split('/')[1]}`
  if (currentRootPath === '/') {
    return getPageRouteForHost(host, restaurant.domainsV2) ?? currentRootPath
  }
  return currentRootPath
}
